import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap/scss/bootstrap.scss'
import 'animate.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import './assets/scss/style.scss'
import 'bootstrap'
import CoolLightBox from 'vue-cool-lightbox'
import VueScrollActive from 'vue-scrollactive'
import AOS from 'aos'
import 'aos/dist/aos.css'
// import VueTypedJs from 'vue-typed-js'

import store from './vuex/store.js';
import { Plugin } from 'vue-fragment';
import Element from 'element-ui';
import './assets/scss/element.scss';

global.__fileServer = "39.152.140.162:10009"
// global.__fileServer = "39.152.140.162:11112"

Vue.config.productionTip = false
Vue.use(CoolLightBox)
Vue.use(VueScrollActive)
// Vue.use(VueTypedJs)
Vue.use(Plugin);
Vue.use(Element);

window.vm = new Vue({
  router,
  store,
  created () {
    AOS.init({
      duration: 800,
      once: true,
    })
  },
  render: h => h(App)
}).$mount('#app')
